import { motion } from "framer-motion";
import { UserSearch, Users, Repeat, ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/mockData";
import { HOME } from "@/constants/testIds";

const EASE = [0.22, 1, 0.36, 1];

const ICONS = {
  "search-user": UserSearch,
  users: Users,
  rpo: Repeat,
};

const Services = () => {
  return (
    <section id="services" className="relative py-20 md:py-28 bg-white">
      <div className="px-5 md:px-10 lg:px-16">
        <div className="flex flex-col items-center text-center mb-14 md:mb-20">
          <div className="text-xs md:text-sm font-display font-semibold tracking-[0.2em] uppercase text-brand-red mb-3">
            Our Services
          </div>
          <h2 className="section-heading section-heading-center font-display font-bold text-4xl md:text-5xl text-brand-ink">
            What We Deliver
          </h2>
          <p className="mt-6 max-w-2xl text-brand-slate text-base md:text-lg leading-relaxed">
            Three ways to work with us — pick one, or thread them together for a
            fully-managed talent function.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || UserSearch;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.1 * i }}
                data-testid={HOME.serviceItem(s.slug)}
                className="group relative bg-white rounded-2xl border-2 border-brand-blue/15 p-8 md:p-10 flex flex-col items-center text-center transition-all hover:border-brand-blue hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(0,75,135,0.12)]"
              >
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-brand-blue-light flex items-center justify-center mb-6 group-hover:bg-brand-blue group-hover:text-white transition-colors">
                  <Icon className="w-10 h-10 md:w-12 md:h-12 text-brand-blue group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-display font-bold text-2xl md:text-[28px] text-brand-ink mb-4">
                  {s.title}
                </h3>
                <p className="text-brand-slate leading-relaxed">
                  {s.body}
                </p>
                <a
                  href="#post-job"
                  className="mt-auto pt-8 inline-flex items-center gap-2 font-display font-semibold text-brand-red hover:text-brand-red-dark transition-colors"
                >
                  {s.cta || "Get started"}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
